import React from 'react';
import OwlCarousel from 'react-owl-carousel3';
import PropTypes from 'prop-types';
import MayLikeItem from './MayLikeItem';
import { Row, Col, Container, Form, InputGroup, Button, Tab, Nav, Image, Badge } from 'react-bootstrap';
import BestSeller from './BestSeller';
import { isOpened, getTodayDates, liefershops, compareNummer } from '../../utils.js';

class ItemsCarousel extends React.Component {
  qty = 0;

  constructor(props) {
    super(props);

    this.onCategoryChange = this.onCategoryChange.bind(this);
    this.generateCategory = this.generateCategory.bind(this);
    this.generateProduct = this.generateProduct.bind(this);
    this.generateSubCategory = this.generateSubCategory.bind(this);
    this.onSubCategoryChange = this.onSubCategoryChange.bind(this);
    this.onExtras = this.onExtras.bind(this);

    const [productItems, categories] = this.generateProduct();
    const categoryItems = this.generateCategory(categories);

    this.state = {
      chosenCategory: null,
      currentCategory: "",
      categoryData: categories,
      categoryItems: categoryItems,
      subCategoriesItems: [],
      chosenSubCategory: null,
      productItems: productItems,
      bestSellerRefs: {},
      categoryDescriptions: {}
    };

    this.onProductAdd = this.onProductAdd.bind(this);
    this.onProductRemove = this.onProductRemove.bind(this);
  }

  componentDidMount() {
    const partnerId = this.props.restaurantInfo?.id;
    if (!partnerId) return;

    fetch(liefershops(`api/v1/category-beschreibung/?partner_id=${partnerId}`))
      .then((response) => response.json())
      .then((data) => {
        const descriptions = {};
        if (Array.isArray(data)) {
          data.forEach((item) => {
            descriptions[item.kategorie] = item.beschreibung;
          });
        }
        this.setState({ categoryDescriptions: descriptions });
      })
      .catch(() => {});
  }

  generateCategory(categories) {
    const categoryItems = [];

    categories.forEach((element) => {
      const categoryItem = (
        <MayLikeItem
          onAdd={this.onCategoryChange}
          title={element.name}
          description={element.description}
          image={element.bild?.image || "img/bild_produkt.webp"}
          imageClass='img-fluid'
          imageAlt={element.name}
          key={`${element.id}-${element.name}`}
        />
      );

      categoryItems.push(categoryItem);
    });

    return categoryItems;
  }

  generateProduct(categorySortName, subCategorySortName) {
    const categories = [];
    const productItems = [];

    const categoryNames = [];

    const sortedProducts = [...this.props.products].sort((a, b) => compareNummer(a.nummer, b.nummer) || a.name.localeCompare(b.name));

    sortedProducts.forEach((element, index) => {
      if (!element.is_active) {
        return;
      }

      const state = isOpened(element);

      const category = element.kategorie;
      const subkategorie = element.subkategorie;

      // A product saved without a category is allowed by the CRM. Reading
      // category.name unguarded threw a TypeError that blanked the ENTIRE
      // menu for the whole restaurant, so one incomplete product record could
      // take the shop offline. Skip such products instead of crashing.
      if (!category || !category.name) {
        return;
      }

      if (!categoryNames.includes(category.name)) {
        categories.push(category);
        categoryNames.push(category.name);
      }

      if (categorySortName !== undefined && categorySortName !== category.name)
        return;

      if (subCategorySortName !== undefined) {
        if (subkategorie == null)
          return;

        if (subCategorySortName !== subkategorie.name)
          return;
      }

      // if (element.zeitraum !== null && !isOpened(element.zeitraum))
      //   return;

      if (state) {
        const item = (
            <Col lg={4} md={4} sm={6} className="mb-4" key={`${element.name}, ${index}`}>
              {/* <Col md={4} sm={6} className="mb-4" key={`${element.name}, ${index}`}></Col> */}
              <BestSeller
                  id={element.id}
                  product={element}
                  title={element.name}
                  subTitle={element.info}
                  imageAlt={element.name}
                  image={element.bild?.image || "img/bild_produkt.webp"}
                  imageClass='w-100 h-100 item-img cover position-absolute'
                  price={isNaN(parseFloat(element.preis)) ? 0 : parseFloat(element.preis)}
                  priceUnit='€ '
                  qty={0}
                  pricePfand={isNaN(parseFloat(element.preis_pfand)) ? 0 : parseFloat(element.preis_pfand)}
                  showPromoted={false}
                  promotedVariant='dark'
                  favIcoIconColor='text-danger'
                  getValue={this.getValue}
                  onAdd={(p) => this.onProductAdd(p)}
                  onRemove={(p) => this.onProductRemove(p)}
                  restaurantInfo={this.props.restaurantInfo}
                  checkOutItem={this.props.checkOutItem}
                  itemsCarousel={this}
                  subCategory={element.subkategorie}
                  getExtras={this.onExtras}
              />

            </Col>
        );


        productItems.push(item);
      }
    });

    return [productItems, categories];
  }

  // Split the flat product list into per-category sections so the menu reads
  // like a printed booklet (Pizza heading + pizzas, Salate heading + salads, …).
  // Returns [{ category, items }] preserving the order in which each category
  // first appears in the sorted product list.
  generateProductSections() {
    const sortedProducts = [...this.props.products].sort(
      (a, b) => (a.nummer ?? 9999) - (b.nummer ?? 9999) || a.name.localeCompare(b.name)
    );

    const orderedCategoryNames = [];
    const sections = new Map();

    sortedProducts.forEach((element, index) => {
      if (!element.is_active) return;
      if (!isOpened(element)) return;

      // Products saved without a category used to be dropped from the menu
      // entirely - invisible and unsellable, with nothing to indicate why.
      // Collect them under a clearly named fallback section instead so the
      // restaurant can still sell them (and can see that they need fixing).
      const category = (element.kategorie && element.kategorie.name)
        ? element.kategorie
        : { id: "__uncategorised__", name: "Weitere Artikel", description: "" };

      if (!sections.has(category.name)) {
        sections.set(category.name, { category, items: [] });
        orderedCategoryNames.push(category.name);
      }

      const item = (
        <Col lg={4} md={4} sm={6} className="mb-4" key={`${element.name}, ${index}`}>
          <BestSeller
            id={element.id}
            product={element}
            title={element.name}
            subTitle={element.info}
            imageAlt={element.name}
            image={element.bild?.image || "img/bild_produkt.webp"}
            imageClass='w-100 h-100 item-img cover position-absolute'
            price={isNaN(parseFloat(element.preis)) ? 0 : parseFloat(element.preis)}
            priceUnit='€ '
            qty={0}
            pricePfand={isNaN(parseFloat(element.preis_pfand)) ? 0 : parseFloat(element.preis_pfand)}
            showPromoted={false}
            promotedVariant='dark'
            favIcoIconColor='text-danger'
            getValue={this.getValue}
            onAdd={(p) => this.onProductAdd(p)}
            onRemove={(p) => this.onProductRemove(p)}
            restaurantInfo={this.props.restaurantInfo}
            checkOutItem={this.props.checkOutItem}
            itemsCarousel={this}
            subCategory={element.subkategorie}
            getExtras={this.onExtras}
          />
        </Col>
      );

      sections.get(category.name).items.push(item);
    });

    return orderedCategoryNames.map(name => sections.get(name));
  }

  addSaveProduct(restaurantId, productName, price, pricepfand, productId, steuer_prozent, product) {
    let restaurantName = `restaurant-products-${restaurantId}`;

    let data = JSON.parse(localStorage.getItem(restaurantName) || "{}");

    if (!data[productName]) {
      data[productName] = {
        id: productId,
        name: productName,
        nummer: product?.props?.product?.nummer ?? null,
        price: price,
        pricepfand: pricepfand,
        amount: 0,
        steuer_prozent: steuer_prozent,
        extras: []
      }
    } else if (data[productName].nummer == null && product?.props?.product?.nummer != null) {
      data[productName].nummer = product.props.product.nummer;
    }

    if (product && product.state.selectedGroesse) {
      data[productName].selectedGroesse = product.state.selectedGroesse;
      data[productName].price = parseFloat(product.state.selectedGroesse.preis) || price;
    }
    if (product && product.state.selectedZusaetze) {
      data[productName].selectedZusaetze = product.state.selectedZusaetze;
    }

    data[productName].amount++;

    localStorage.setItem(restaurantName, JSON.stringify(data));
  }

  removeSaveProduct(restaurantId, productName) {
    let restaurantName = `restaurant-products-${restaurantId}`;
    let data = JSON.parse(localStorage.getItem(restaurantName) || "{}");

    if (Object.keys(data).length === 0) {
      return;
    }

    if (!data[productName]) {
      return;
    }

    data[productName].amount--;

    if (data[productName].amount === 0) {
      delete data[productName];
    }

    localStorage.setItem(restaurantName, JSON.stringify(data));
  }

  onExtras(product, data, extras) {
    const quantity = data.quantity;
    const price = extras.price;

    const extraSave = {
      id: extras.id,
      name: extras.name,
      amount: quantity,
      price: price
    };

    const products = JSON.parse(localStorage.getItem(`restaurant-products-${product.props.restaurantInfo.id}`) || "{}");
    if (Object.keys(products).length === 0) {
      return;
    }

    if (!products[product.props.title]) {
      return;
    }

    let savedExtras = products[product.props.title].extras || [];

    let newExtras = savedExtras.filter(element => {
      if (element.name === extraSave.name) {
        if (extraSave.amount === 0) {
          return false;
        }
        element.amount = extraSave.amount;
        element.price = extraSave.price;
      }
      return true;
    });

    if (!savedExtras.some(e => e.name === extraSave.name) && extraSave.amount > 0) {
      newExtras.push(extraSave);
    }

    products[product.props.title].extras = newExtras;

    localStorage.setItem(`restaurant-products-${product.props.restaurantInfo.id}`, JSON.stringify(products));

    this.props.checkOutItem.current.loadExtras(product);
  }

  onProductAdd(product) {
    let checkOutItem = this.props.checkOutItem.current;

    product.addItem();

    checkOutItem.setFunctions(this.onProductAdd, this.onProductRemove);
    checkOutItem.addProductItem(product);

    this.addSaveProduct(this.props.restaurantInfo.id, product.props.title, product.getPrice(), product.getPricePfand(), product.props.id, product.props.product.kategorie.steuer_prozent, product);
  }

  removeProductItem(product) {
    let checkOutItem = this.props.checkOutItem.current;

    let state = checkOutItem.state;
    let title = product.props.title;

    let elementRef = state.checkOutItemRefs[title];
    if (elementRef) {
      let current = elementRef.current;

      if (current.state.quantity <= 1) {
        delete state.checkOutItemRefs[title];
        state.totalItems -= 1;

        state.checkOutItems.forEach((element) => {
          if (element.props.itemName !== title)
            return;

          let index = state.checkOutItems.indexOf(element);
          if (index === -1)
            return;

          state.checkOutItems.splice(index, 1);
        });
      }
    }
  }

  onProductRemove(product) {
    let checkOutItem = this.props.checkOutItem.current;

    product.removeItem();
    checkOutItem.removeProductItem(product);

    this.removeSaveProduct(this.props.restaurantInfo.id, product.props.title);

    this.removeProductItem(product);
  }

  setCurrentCategory(categoryName) {
    const [product, _] = this.generateProduct(categoryName);

    return product;
  }

  onCategoryChange(item, itemState) {
    let newState = this.state;
    const categoryItem = newState.chosenCategory;

    if (categoryItem) {
      categoryItem.changeStyle(false);
    }

    if (itemState) {
      item.changeStyle(true);

      newState.productItems = this.setCurrentCategory(item.props.title);
      newState.chosenCategory = item;
      newState.subCategoriesItems = this.generateSubCategory(newState.productItems);
    } else {
      item.changeStyle(false);
      newState.chosenCategory = null;
      const [product, _] = this.generateProduct();
      newState.productItems = product;
      newState.subCategoriesItems = [];
    }

    newState.chosenSubCategory = null;

    this.setState(newState);
  }

  generateSubCategory(products) {
    const subCategoryItems = [];

    const subCategoryNames = [];

    products.forEach((element) => {
      let subkategorie = element.props.children.props.subCategory

      if (subkategorie == null) {
        return;
      }

      if (subCategoryNames.includes(subkategorie.name)) {
        return;
      }

      subCategoryNames.push(subkategorie.name);

      const subCategoryItem = (
        <MayLikeItem
          onAdd={this.onSubCategoryChange}
          title={subkategorie.name}
          image={subkategorie.bild?.image || "img/bild_produkt.webp"}
          imageClass='img-fluid'
          imageAlt='carousel'
          key={`${subkategorie.id}-${subkategorie.name}`}
        />
      );

      subCategoryItems.push(subCategoryItem);
    });

    return subCategoryItems;
  }

  onSubCategoryChange(item, itemState) {
    let newState = this.state;
    const categoryItem = newState.chosenCategory;
    const subCategoryItem = newState.chosenSubCategory;

    if (subCategoryItem) {
      subCategoryItem.changeStyle(false);
    }

    if (itemState) {
      item.changeStyle(true);

      const [product, _] = this.generateProduct(categoryItem.props.title, item.props.title);
      newState.productItems = product;
      newState.chosenSubCategory = item;

    } else {
      item.changeStyle(false);
      newState.chosenSubCategory = null;
      const [product, _] = this.generateProduct(categoryItem.props.title);
      newState.productItems = product;
    }

    this.setState(newState);
  }

  /**
   * Description text for a category, resolved in priority order:
   *   1. the partner-specific text (KategorieBeschreibungModel, edited per
   *      restaurant), then
   *   2. the global text on the category itself (KategorieModel.description,
   *      which is what the "Kategorie Beschreibung" field in the CRM writes to).
   *
   * Only the partner-specific source used to be consulted, so a description
   * typed into the CRM never appeared anywhere on the customer site.
   * Returns "" when there is nothing to show.
   */
  descriptionForCategory(category) {
    if (!category) return "";
    const perPartner = this.state.categoryDescriptions[category.id];
    if (perPartner) return perPartner;
    return category.description || "";
  }

  getCategoryDescription() {
    const chosen = this.state.chosenCategory;
    if (!chosen) return "Alle Artikel";

    const categoryName = chosen.props.title;
    const category = this.state.categoryData.find(c => c.name === categoryName);
    return this.descriptionForCategory(category) || chosen.props.description || categoryName;
  }

  getValue(value) {

  }

  render() {
    return (
      <>
        {this.state.categoryItems.length > 0 &&
          (
            <OwlCarousel {...options} className="owl-theme owl-carousel-five offers-interested-carousel owl-carousel-category">
              {this.state.categoryItems}
            </OwlCarousel>
          )
        }


        {/* <OwlCarousel nav {...options} className="owl-theme owl-carousel-five offers-interested-carousel owl-carousel-category">
          {this.state.categoryItems}
        </OwlCarousel> */}

        {this.state.subCategoriesItems.length !== 0 ?
          (<h5 className='mb-4 mt-3'>Unterkategorien</h5>) : ""
        }

        {this.state.subCategoriesItems.length > 0 &&
          (
            <OwlCarousel {...options} className="owl-theme owl-carousel-five offers-interested-carousel owl-carousel-category">
              {this.state.subCategoriesItems}
            </OwlCarousel>
          )
        }

        {this.state.chosenCategory === null ? (
          this.generateProductSections().map(section => {
            const description = this.descriptionForCategory(section.category);
            return (
              <React.Fragment key={`section-${section.category.id}`}>
                <h4 className="mb-1 mt-4 col-md-12 menu-section-title border-bottom pb-2">
                  {section.category.name}
                </h4>
                {description ? (
                  <p className="col-md-12 text-gray mb-3" style={{ fontSize: "0.95rem" }}>
                    {description}
                  </p>
                ) : null}
                <Row>{section.items}</Row>
              </React.Fragment>
            );
          })
        ) : (
          <Row>
            <h5 className="mb-4 mt-3 col-md-12">{this.getCategoryDescription()}</h5>
            {this.state.productItems}
          </Row>
        )}
      </>
    );
  }
}

ItemsCarousel.propTypes = {
  products: PropTypes.array.isRequired,
  onCategoryAdd: PropTypes.func.isRequired,
  checkOutItem: PropTypes.any.isRequired,
  restaurantInfo: PropTypes.any.isRequired
}

ItemsCarousel.defaultProps = {
  products: []
}

const options = {
  responsive: {
    0: {
      items: 2,
    },
    600: {
      items: 3,
    },
    1000: {
      items: 4,
    },
    1200: {
      items: 5,
    },
  },
  lazyLoad: true,
  pagination: "false",
  loop: false, /*bis ende dreht carousel und stopt, nicht dupliziert items*/
  rewind: true,
  /* loop: true, */
  dots: false,
  /* dots: false, */
  autoplay: true,
  autoplaySpeed: 700,
  /* autoplaySpeed: 1000, */
  autoplayTimeout: 5000,
  /* autoplayTimeout: 2000, */
  autoplayHoverPause: true,
  nav: true,
  navText: ["<i class='icofont-thin-left'></i>", "<i class='icofont-thin-right'></i>"]
}

export default ItemsCarousel;